import { TargetAndTransition } from 'framer-motion'

const springConfig = { damping: 25, stiffness: 300 }
const initialScale = 0.75

export const initialAnimationState = {
  opacity: 0,
  scale: initialScale,
}

export const entryAnimation: TargetAndTransition = {
  opacity: 1,
  scale: 1,
  transition: springConfig,
}
